export enum RequestTypeEnum {
  /**
   * A contract attenstation request.
   */
  ContractAttestation = 1,

  /**
   * A contract settlement request.
   */
  ContractSettlement = 2,
}
